import React, { useEffect, useRef, useState } from 'react';

const CITIES = ['LOS ANGELES', 'DALLAS', 'SAN FRANCISCO', 'HAWAII', 'LOUISIANA', 'COLORADO', 'ATLANTA'];

function scrollTo(id) {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth' });
}

export default function Hero() {
  const [cityIdx, setCityIdx] = useState(0);
  const [cityVisible, setCityVisible] = useState(true);
  const particleRef = useRef(null);

  useEffect(() => {
    const interval = setInterval(() => {
      setCityVisible(false);
      setTimeout(() => {
        setCityIdx(i => (i + 1) % CITIES.length);
        setCityVisible(true);
      }, 350);
    }, 2600);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (!particleRef.current) return;
    const container = particleRef.current;
    for (let i = 0; i < 40; i++) {
      const p = document.createElement('div');
      const size = 1 + Math.random() * 2;
      const dur = 7 + Math.random() * 10;
      const delay = Math.random() * 12;
      const drift = (Math.random() - 0.5) * 120;
      p.style.cssText = `
        position:absolute; border-radius:50%;
        background:#C8440A;
        width:${size}px; height:${size}px;
        left:${Math.random() * 100}%;
        bottom:0;
        animation: particleRise ${dur}s ${delay}s linear infinite;
        --drift: ${drift}px;
      `;
      container.appendChild(p);
    }
  }, []);

  return (
    <section id="hero" style={{
      position: 'relative', minHeight: '100vh',
      display: 'flex', flexDirection: 'column', justifyContent: 'flex-end',
      padding: '0 64px 88px', overflow: 'hidden',
    }}>
      <style>{`
        @keyframes particleRise {
          0% { transform: translateY(0) translateX(0); opacity: 0; }
          10% { opacity: 0.8; }
          90% { opacity: 0.4; }
          100% { transform: translateY(-100vh) translateX(var(--drift)); opacity: 0; }
        }
        @keyframes gridPulse { 0%,100%{opacity:.3} 50%{opacity:.8} }
        .hero-animate-1 { animation: fadeUp 0.8s ease 0.2s both; }
        .hero-animate-2 { animation: fadeUp 0.8s ease 0.45s both; }
        .hero-animate-3 { animation: fadeUp 0.8s ease 0.65s both; }
        .hero-animate-4 { animation: fadeUp 0.8s ease 0.85s both; }
        @media(max-width:768px){
          #hero { padding: 0 24px 72px !important; }
          .hero-title { font-size: clamp(64px, 18vw, 120px) !important; }
        }
      `}</style>

      {/* BG layers */}
      <div style={{ position: 'absolute', inset: 0, background: 'radial-gradient(ellipse 80% 60% at 60% 40%, rgba(200,68,10,0.2) 0%, transparent 70%), radial-gradient(ellipse 40% 40% at 15% 75%, rgba(212,168,67,0.07) 0%, transparent 60%), linear-gradient(180deg, rgba(8,8,8,0) 0%, rgba(8,8,8,0.5) 60%, rgba(8,8,8,1) 100%)', zIndex: 1 }} />
      <div style={{ position: 'absolute', inset: 0, backgroundImage: 'linear-gradient(rgba(200,68,10,0.04) 1px,transparent 1px),linear-gradient(90deg,rgba(200,68,10,0.04) 1px,transparent 1px)', backgroundSize: '80px 80px', zIndex: 0, animation: 'gridPulse 8s ease-in-out infinite' }} />
      <div ref={particleRef} style={{ position: 'absolute', inset: 0, zIndex: 1, overflow: 'hidden' }} />

      {/* Content */}
      <div style={{ position: 'relative', zIndex: 2 }}>
        <p className="hero-animate-1" style={{ fontFamily: 'var(--font-body)', fontSize: 11, letterSpacing: '0.3em', textTransform: 'uppercase', color: 'var(--ember)', marginBottom: 16 }}>
          May – June 2026 &nbsp;·&nbsp; 8 Cities &nbsp;·&nbsp; One Night. One City. Everything Changes.
        </p>
        <h1 className="hero-animate-2" style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(80px, 13vw, 172px)', lineHeight: 0.9, letterSpacing: '0.02em', color: 'var(--white)' }}>
          REVIVE<br />
          <span style={{
            color: 'var(--ember)', display: 'inline-block', position: 'relative',
            opacity: cityVisible ? 1 : 0,
            transform: cityVisible ? 'translateY(0)' : 'translateY(14px)',
            transition: 'opacity 0.35s ease, transform 0.35s ease',
          }}>
            {CITIES[cityIdx]}
            <span style={{ position: 'absolute', bottom: 4, left: 0, right: 0, height: 3, background: 'linear-gradient(90deg, var(--ember), var(--gold), transparent)' }} />
          </span>
        </h1>
        <p className="hero-animate-3" style={{ fontFamily: 'var(--font-serif)', fontStyle: 'italic', fontSize: 'clamp(18px, 2.2vw, 26px)', color: 'rgba(245,240,232,0.6)', marginTop: 20, maxWidth: 560 }}>
          A generation awakened. A city transformed.
        </p>
        <div className="hero-animate-4" style={{ display: 'flex', gap: 16, marginTop: 40, flexWrap: 'wrap' }}>
          <button onClick={() => scrollTo('register')}
            style={{ background: 'var(--ember)', color: 'var(--white)', padding: '16px 40px', fontFamily: 'var(--font-body)', fontSize: 12, fontWeight: 500, letterSpacing: '0.2em', textTransform: 'uppercase', border: 'none' }}
            onMouseEnter={e => { e.target.style.background = 'var(--ember-light)'; e.target.style.transform = 'translateY(-2px)'; }}
            onMouseLeave={e => { e.target.style.background = 'var(--ember)'; e.target.style.transform = 'translateY(0)'; }}>
            Register For Free
          </button>
          <button onClick={() => scrollTo('cities')}
            style={{ background: 'transparent', color: 'var(--white)', padding: '16px 40px', fontFamily: 'var(--font-body)', fontSize: 12, fontWeight: 400, letterSpacing: '0.2em', textTransform: 'uppercase', border: '1px solid rgba(245,240,232,0.25)' }}
            onMouseEnter={e => { e.target.style.borderColor = 'var(--gold)'; e.target.style.color = 'var(--gold)'; }}
            onMouseLeave={e => { e.target.style.borderColor = 'rgba(245,240,232,0.25)'; e.target.style.color = 'var(--white)'; }}>
            Find Your City
          </button>
        </div>
      </div>

      {/* Scroll hint */}
      <div style={{ position: 'absolute', bottom: 32, right: 64, display: 'flex', alignItems: 'center', gap: 12, fontSize: 10, letterSpacing: '0.25em', textTransform: 'uppercase', color: 'rgba(245,240,232,0.25)', zIndex: 2, animation: 'fadeUp 0.8s ease 1.4s both' }}>
        <style>{`
          @keyframes scrollLineAnim { 0%{left:-100%} 100%{left:100%} }
          .scroll-line-inner { animation: scrollLineAnim 2s ease-in-out infinite; }
        `}</style>
        <div style={{ width: 48, height: 1, background: 'linear-gradient(90deg,transparent,rgba(245,240,232,0.25))', position: 'relative', overflow: 'hidden' }}>
          <div className="scroll-line-inner" style={{ position: 'absolute', top: 0, left: '-100%', width: '100%', height: '100%', background: 'var(--ember)' }} />
        </div>
        Scroll to explore
      </div>
    </section>
  );
}
